export default __webpack_public_path__ + "static/media/K2D-Bold.304de988.ttf";